const questions = [
  {
    id: 'projectType',
    step: 1,
    title: 'RiskCalculator.question.projectType.title',
    multiple: false,
    options: [
      {
        label: 'RiskCalculator.projectType.residential.label',
        subtitle: 'RiskCalculator.projectType.residential.subtitle',
        value: 'residential',
        score: 2,
      },
      {
        label: 'RiskCalculator.projectType.civil.label',
        subtitle: 'RiskCalculator.projectType.civil.subtitle',
        value: 'civil',
        score: 3,
      },
      {
        label: 'RiskCalculator.projectType.infrastructure.label',
        subtitle: 'RiskCalculator.projectType.infrastructure.subtitle',
        value: 'infrastructure',
        score: 4,
      },
      {
        label: 'RiskCalculator.projectType.renovation.label',
        subtitle: 'RiskCalculator.projectType.renovation.subtitle',
        value: 'renovation',
        score: 1,
      },
    ],
  },

  {
    id: 'siteSize',
    step: 2,
    title: 'RiskCalculator.question.siteSize.title',
    multiple: false,
    options: [
      {
        label: 'RiskCalculator.siteSize.under1000.label',
        subtitle: 'RiskCalculator.siteSize.under1000.subtitle',
        value: 'under1000',
        score: 1,
      },
      {
        label: 'RiskCalculator.siteSize.1000to5000.label',
        subtitle: 'RiskCalculator.siteSize.1000to5000.subtitle',
        value: '1000-5000',
        score: 2,
      },
      {
        label: 'RiskCalculator.siteSize.5000to20000.label',
        subtitle: 'RiskCalculator.siteSize.5000to20000.subtitle',
        value: '5000-20000',
        score: 3,
      },
      {
        label: 'RiskCalculator.siteSize.over20000.label',
        subtitle: 'RiskCalculator.siteSize.over20000.subtitle',
        value: 'over20000',
        score: 4,
      },
    ],
  },

  {
    id: 'materials',
    step: 3,
    title: 'RiskCalculator.question.materials.title',
    multiple: true,
    options: [
      {
        label: 'RiskCalculator.materials.cables.label',
        subtitle: 'RiskCalculator.materials.cables.subtitle',
        value: 'cables',
        score: 3,
      },
      {
        label: 'RiskCalculator.materials.diesel.label',
        subtitle: 'RiskCalculator.materials.diesel.subtitle',
        value: 'diesel',
        score: 3,
      },
      {
        label: 'RiskCalculator.materials.machines.label',
        subtitle: 'RiskCalculator.materials.machines.subtitle',
        value: 'machines',
        score: 2,
      },
      {
        label: 'RiskCalculator.materials.tools.label',
        subtitle: 'RiskCalculator.materials.tools.subtitle',
        value: 'tools',
        score: 2,
      },
      {
        label: 'RiskCalculator.materials.buildingMaterials.label',
        subtitle: 'RiskCalculator.materials.buildingMaterials.subtitle',
        value: 'materials',
        score: 1,
      },
      {
        label: 'RiskCalculator.materials.none.label',
        subtitle: 'RiskCalculator.materials.none.subtitle',
        value: 'none',
        score: 0,
        exclusive: true,
      },
    ],
  },

  {
    id: 'occupied',
    step: 4,
    title: 'RiskCalculator.question.occupied.title',
    multiple: false,
    options: [
      {
        label: 'RiskCalculator.occupied.always.label',
        subtitle: 'RiskCalculator.occupied.always.subtitle',
        value: 'always',
        score: 4,
      },
      {
        label: 'RiskCalculator.occupied.sometimes.label',
        subtitle: 'RiskCalculator.occupied.sometimes.subtitle',
        value: 'sometimes',
        score: 2,
      },
      {
        label: 'RiskCalculator.occupied.never.label',
        subtitle: 'RiskCalculator.occupied.never.subtitle',
        value: 'never',
        score: 0,
      },
    ],
  },

  {
    id: 'theftHistory',
    step: 5,
    title: 'RiskCalculator.question.theftHistory.title',
    multiple: false,
    options: [
      {
        label: 'RiskCalculator.theftHistory.yes.label',
        subtitle: 'RiskCalculator.theftHistory.yes.subtitle',
        value: 'yes',
        score: 4,
      },
      {
        label: 'RiskCalculator.theftHistory.unknown.label',
        subtitle: 'RiskCalculator.theftHistory.unknown.subtitle',
        value: 'unknown',
        score: 2,
      },
      {
        label: 'RiskCalculator.theftHistory.no.label',
        subtitle: 'RiskCalculator.theftHistory.no.subtitle',
        value: 'no',
        score: 0,
      },
    ],
  },
];

export default questions;